/**
 * Tokens de integração do tenant (LAC-105 · DOC 06 § 5.3).
 * Helper HTTP — JWT do painel; plain_text_token só no POST create.
 */

import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

/** Escopos de integração — contacts (CRM) e/ou messages (POST /messages). */
export type ApiTokenScope = "contacts" | "messages";

export type ApiToken = {
  id: number;
  name: string;
  /** Prefixo mascarado (ex. be_token_ab12…) — não é o segredo completo. */
  token_prefix?: string | null;
  /** Vazio/omitido na API = full (contacts+messages). */
  scopes?: ApiTokenScope[] | string[];
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
  updated_at?: string;
  /** Só na resposta do create — nunca na listagem. */
  plain_text_token?: string;
  last_failure?: {
    at: string;
    to_email: string;
    skip_reason: string | null;
  } | null;
  /** Último HTTP 429 deste token (ISO) — Redis; null se nunca. */
  last_429_at?: string | null;
  rate_limit?: {
    per_minute: number;
    remaining: number;
  } | null;
};

export const getApiTokens = (params?: {
  include_revoked?: boolean;
}): Promise<ApiSuccess<ApiToken[]>> => {
  return axios.get(apiBase + "/api-tokens", {
    params: {
      include_revoked: params?.include_revoked ? 1 : undefined,
    },
  });
};

export const createApiToken = (payload: {
  name: string;
  /** Omitir ou ambos = full access. */
  scopes?: ApiTokenScope[];
}): Promise<ApiSuccess<ApiToken>> => {
  return axios.post(apiBase + "/api-tokens", payload);
};

export const revokeApiToken = (
  id: number
): Promise<ApiSuccess<ApiToken>> => {
  return axios.post(apiBase + "/api-tokens/" + id + "/revoke");
};
